import styled from 'styled-components'
import theme from 'theme_'

export const HomeSoftwareUpdateProgressContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${theme.spacing.lg};
`
